// Preços definidos pelo usuário. Capacidades e distribuição de recursos propostas para revisão.
export const pricingStatus = 'published';

export const plans = [
  {
    name: 'Essencial',
    price: 199,
    description: 'Para reunir os atendimentos e organizar uma equipe pequena.',
    collaborators: 5,
    whatsappInboxes: 1,
    emailInboxes: 3,
    storageGb: 50,
    resourceId: 'crm',
    items: ['Atendimento centralizado', 'Contatos e histórico de conversas', 'Etiquetas e notas internas', 'Respostas prontas'],
    cta: 'Quero o Essencial',
  },
  {
    name: 'Equipe',
    price: 399,
    description: 'Para conectar departamentos e acompanhar uma operação em crescimento.',
    collaborators: 10,
    whatsappInboxes: 2,
    emailInboxes: 10,
    storageGb: 100,
    resourceId: 'gestor',
    items: ['Todos os recursos do Essencial', 'Gestor de Arquivos', 'Pastas e subpastas para organizar', 'Busca pelo conteúdo dos documentos', 'Salvar anexos do atendimento em pastas'],
    cta: 'Quero o Equipe',
  },
  {
    name: 'Profissional',
    price: 699,
    description: 'Para unir atendimento, documentos e conversas entre os departamentos.',
    collaborators: 25,
    whatsappInboxes: 3,
    emailInboxes: 20,
    storageGb: 250,
    resourceId: 'chat',
    featured: true,
    items: ['Todos os recursos do Equipe', 'Chat Interno entre colaboradores', 'Grupos para os departamentos', 'Conversa interna na mesma plataforma'],
    cta: 'Quero o Profissional',
  },
  {
    name: 'Escala',
    price: 999,
    description: 'Para ampliar o atendimento e organizar o financeiro e a cobrança da contabilidade.',
    collaborators: 50,
    whatsappInboxes: 5,
    emailInboxes: 30,
    storageGb: 500,
    resourceId: 'hub',
    resourceIds: ['hub', 'finance'],
    items: ['Todos os recursos do Profissional', 'Hub de Arquivos', 'Cont Finance', 'Gestão financeira e de cobrança', 'Mais capacidade para equipes e arquivos'],
    cta: 'Quero o Escala',
  },
  { name: 'Enterprise', price: null, enterprise: true, resourceId: 'enterprise', description: 'Conecte o atendimento às soluções de BPO, gestão financeira e contábil da sua operação.', items: ['Todos os recursos do Escala', 'Software para gestão de BPO', 'Gestão financeira e da contabilidade', 'Entrega de boletos e cobrança dos contratos', 'Usuários, canais e armazenamento sob medida'], cta: 'Solicitar proposta Enterprise' },
];

export const planOptions = [...plans.map(plan => plan.name), 'Quero ajuda para escolher'];

export const resources = [
  {
    id: 'crm', title: 'CRM de atendimento', minPlanIndex: 0,
    summary: 'Canais, contatos e histórico para a equipe atender com contexto.',
    description: 'Uma base compartilhada para receber mensagens, organizar as conversas e acompanhar os retornos do escritório.',
    bullets: ['Reúna os canais conectados em uma central.', 'Consulte contatos e o histórico das conversas.', 'Use etiquetas, notas internas e respostas prontas.', 'Atribua os atendimentos às pessoas e equipes responsáveis.'],
  },
  {
    id: 'gestor', title: 'Gestor de Arquivos', minPlanIndex: 1,
    summary: 'Salve o anexo na pasta certa e encontre documentos também pelo conteúdo.',
    description: 'O arquivo recebido no atendimento pode ser salvo diretamente na biblioteca do escritório. Organize por pastas e subpastas e pesquise as informações presentes nos documentos.',
    bullets: ['Salve anexos da conversa na pasta que você escolher.', 'Organize a biblioteca por empresa, departamento ou assunto.', 'Pesquise por nome, observação e conteúdo dos arquivos processados.', 'Consulte o arquivo e o vínculo com o atendimento de origem.'],
    note: 'A busca pelo conteúdo depende do formato, do tamanho e do processamento do arquivo. A configuração da pesquisa é validada na implantação.',
  },
  {
    id: 'chat', title: 'Chat Interno', minPlanIndex: 2,
    summary: 'Grupos da equipe dentro do ContDesk, separados das conversas com clientes.',
    description: 'Converse com os colaboradores na própria plataforma e alinhe demandas entre departamentos. O administrador organiza os grupos e define os participantes.',
    bullets: ['Crie grupos como Fiscal, Pessoal e Financeiro.', 'Defina os colaboradores que participam de cada grupo.', 'Troque mensagens e arquivos no contexto da equipe.', 'Alinhe o retorno sem misturar o chat interno com o atendimento ao cliente.'],
  },
  {
    id: 'hub', title: 'Hub de Arquivos', minPlanIndex: 3, beta: true,
    summary: 'Produto conectado ao ContDesk para ampliar a organização de arquivos. Em Beta.',
    description: 'O Hub de Arquivos amplia a organização de arquivos por meio de uma solução conectada à operação. Está em Beta: conexão, recursos habilitados e disponibilidade são alinhados com a RMS na proposta.',
    bullets: ['Produto conectado à operação do ContDesk.', 'Disponível na composição do plano Escala e do Enterprise.', 'Habilitação e configuração definidas com a RMS.'],
    note: 'Beta indica uma fase de evolução do produto. Confirme com a RMS a disponibilidade e o escopo antes de contratar este recurso.',
  },
  {
    id: 'finance', title: 'Cont Finance', minPlanIndex: 3,
    summary: 'Gestor financeiro da contabilidade, com organização e acompanhamento das cobranças.',
    description: 'O Cont Finance entra no plano Escala para ajudar a contabilidade a administrar o próprio financeiro e a gestão de cobrança. O escritório acompanha compromissos, recebimentos e cobranças em uma solução dedicada, conectada à sua operação conforme a implantação.',
    bullets: ['Gestão do financeiro da própria contabilidade.', 'Organização e acompanhamento das cobranças.', 'Controle dos recebimentos e das pendências financeiras.', 'Composição com o atendimento do ContDesk definida na implantação.'],
    note: 'A gestão de cobrança não equivale à execução automática de pagamentos. Emissão de boletos, tarifas, integrações bancárias e habilitações dependem da configuração e da proposta comercial.',
  },
  {
    id: 'enterprise', title: 'Gestão para sua operação', minPlanIndex: 4,
    summary: 'Soluções de BPO, gestão financeira e contábil e cobrança de contratos, sob consulta.',
    description: 'O Enterprise conecta o atendimento às soluções necessárias para administrar a operação. A proposta define quais produtos e integrações compõem o projeto, com implantação e condições próprias.',
    bullets: ['Software para gestão de BPO.', 'Gestão financeira e da contabilidade.', 'Entrega de boletos e cobrança dos contratos.', 'Dimensionamento de usuários, canais e armazenamento.'],
    note: 'O Enterprise é sob consulta. Os sistemas incluídos, as integrações e as condições de implantação são definidos na proposta comercial.',
  },
];

export function getResource(id) { return resources.find(resource => resource.id === id); }
